export const LOGIN_ROUTE = "/users/login";
export const DEVICE_ROUTE = "/devices";
export const PATIENT_ROUTE = "/patients";
export const USER_ROUTE = "/users";
export const HOSPITAL_ROUTE = "/hospitals";